import dynamic from 'next/dynamic';
import A from './components/A';
import Header from './components/Header';
import css from './index.module.scss';

const IndexDynamic = dynamic(() => import('./indexDynamic'), {
    ssr: true,
});

export default function OverviewDE({ langKey }: any) {
    return (
        <div className={`power-ocean-collection ${css['power-ocean-collection']}`}>
            {langKey === 'solarspeicher' && <Header langKey={langKey} />}
            <A langKey={langKey} />
            <IndexDynamic langKey={langKey} />
            <style jsx global>
                {`
                    .product_naver_h5 .right .ef-button {
                        margin-left: 0.12rem !important;
                        padding: 0 0.06rem !important;
                        font-size: 0.12rem !important;
                    }
                `}
            </style>
        </div>
    );
}
